import Restaurant from '@components/restaurant/models/Restaurant';
import { Box, ButtonBase, Paper } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import RestaurantHeader from './RestaurantHeader';
import RestaurantImage from './RestaurantImage';
import RestaurantStatus from './RestaurantStatus';
import { useNavigate } from 'react-router-dom';

interface RestaurantItemProps {
    restaurant: Restaurant;
    onClick: (restaurant: Restaurant) => void;
}

const RestaurantItem: React.FC<RestaurantItemProps> = observer(({ restaurant, onClick }) => {
    return (
        <ButtonBase
            onClick={() => onClick(restaurant)}
            sx={(theme) => ({
                width: "100%",
                [theme.breakpoints.up("sm")]: {
                    // maxWidth: 372
                },
                "&:hover": {
                    "& #restaurant-card-media": {
                          transform: "scale(1.04)",
                    },
                    boxShadow: (theme) => theme.shadows[1]
                },
            })}>
            <Paper sx={{ width: "100%", p: 0 }}>
                <RestaurantImage restaurant={restaurant} />
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    p={1}
                    pl={1.5}>
                    <RestaurantHeader restaurant={restaurant} />
                    {/* <RestaurantStatus restaurant={restaurant} /> */}
                </Box>
            </Paper>
        </ButtonBase>
    )
})

export default RestaurantItem;